<template>
  <div class="battery">
    <AddressUSA
      v-if="currentNode.question.question_type === 'address_usa'"
      :key="currentNode.id"
      :node="currentNode"
      :skip-button="skipButton"
      :submit-button="submitButton"
      @answer="onAnswerQuestion"
      @skip="onSkipQuestion"
    >
    </AddressUSA>
    <Information
      v-if="currentNode.question.question_type === 'info'"
      :key="currentNode.id"
      :node="currentNode"
      :continue-button="continueButton"
      @answer="onAnswerQuestion"
      @skip="onSkipQuestion"
      @complete="onCompleteBattery"
    >
    </Information>
    <MultilineTextQuestion
      v-if="currentNode.question.question_type === 'multiline'"
      :key="currentNode.id"
      :node="currentNode"
      :skip-button="skipButton"
      :submit-button="submitButton"
      @answer="onAnswerQuestion"
      @skip="onSkipQuestion"
    >
    </MultilineTextQuestion>
    <MultipleChoiceQuestion
      v-if="currentNode.question.question_type === 'mc'"
      :key="currentNode.id"
      :node="currentNode"
      :skip-button="skipButton"
      :submit-button="submitButton"
      @answer="onAnswerQuestion"
      @skip="onSkipQuestion"
    >
    </MultipleChoiceQuestion>
    <RatingQuestion
      v-if="currentNode.question.question_type === 'rating'"
      :key="currentNode.id"
      :node="currentNode"
      :skip-button="skipButton"
      :submit-button="submitButton"
      @answer="onAnswerQuestion"
      @skip="onSkipQuestion"
    >
    </RatingQuestion>
    <SelectionQuestion
      v-if="currentNode.question.question_type === 'selection'"
      :key="currentNode.id"
      :node="currentNode"
      :skip-button="skipButton"
      :submit-button="submitButton"
      @answer="onAnswerQuestion"
      @skip="onSkipQuestion"
    >
    </SelectionQuestion>
    <TextQuestion
      v-if="currentNode.question.question_type === 'text'"
      :key="currentNode.id"
      :node="currentNode"
      :skip-button="skipButton"
      :submit-button="submitButton"
      @answer="onAnswerQuestion"
      @skip="onSkipQuestion"
    >
    </TextQuestion>
    <ImageQuestion
      v-if="currentNode.question.question_type === 'image'"
      :key="currentNode.id"
      :node="currentNode"
      :skip-button="skipButton"
      :submit-button="submitButton"
      @answer="onAnswerQuestion"
      @skip="onSkipQuestion"
    >
    </ImageQuestion>
    <ProductLabelQuestion
      v-if="currentNode.question.question_type === 'product_label'"
      :key="currentNode.id"
      :node="currentNode"
      :productLabel="productLabel"
      :skip-button="skipButton"
      :submit-button="submitButton"
      @capture="onCaptureLabel"
      @answer="onAnswerQuestion"
      @skip="onSkipQuestion"
    >
    </ProductLabelQuestion>
    <TimeQuestion
      v-if="currentNode.question.question_type === 'time'"
      :key="currentNode.id"
      :node="currentNode"
      :skip-button="skipButton"
      :submit-button="submitButton"
      @answer="onAnswerQuestion"
      @skip="onSkipQuestion"
    >
    </TimeQuestion>
    <ValidateQuestion
      v-if="currentNode.question.question_type === 'validate'"
      :key="currentNode.id"
      :node="currentNode"
      :skip-button="skipButton"
      :submit-button="submitButton"
      @answer="onAnswerQuestion"
      @skip="onSkipQuestion"
    >
    </ValidateQuestion>
    <RankingQuestion
      v-if="currentNode.question.question_type === 'ranking'"
      :key="currentNode.id"
      :node="currentNode"
      :skip-button="skipButton"
      :submit-button="submitButton"
      @answer="onAnswerQuestion"
      @skip="onSkipQuestion"
    >
    </RankingQuestion>
    <div class="fineprint">
      <a href="/support/" target="_blank">support</a><br />
      <a href="/terms/" target="_blank">terms &amp; conditions</a><br />
      <a href="/privacy/" target="_blank">privacy policy</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AddressUSA from './AddressUSA.vue';
import Information from './Information.vue';
import MultilineTextQuestion from './MultilineTextQuestion.vue';
import MultipleChoiceQuestion from './MultipleChoiceQuestion.vue';
import RatingQuestion from './RatingQuestion.vue';
import SelectionQuestion from './SelectionQuestion.vue';
import ImageQuestion from './ImageQuestion.vue';
import TextQuestion from './TextQuestion.vue';
import TimeQuestion from './TimeQuestion.vue';
import ProductLabelQuestion from './ProductLabelQuestion.vue';
import ValidateQuestion from './ValidateQuestion.vue';
import RankingQuestion from './RankingQuestion.vue';

export default {
  name: 'Battery',
  components: {
    AddressUSA,
    Information,
    MultilineTextQuestion,
    MultipleChoiceQuestion,
    RatingQuestion,
    RankingQuestion,
    SelectionQuestion,
    ImageQuestion,
    ProductLabelQuestion,
    TextQuestion,
    TimeQuestion,
    ValidateQuestion,
  },
  computed: {
    ...mapState(['currentNode', 'productLabel', 'continueButton', 'skipButton', 'submitButton']),
  },
  methods: {
    onCaptureLabel(info) {
      this.$emit('capture', info);
    },
    onAnswerQuestion(info) {
      this.$emit('question', info);
    },
    onSkipQuestion() {
      this.$emit('skip');
    },
    onCompleteBattery() {
      this.$emit('complete');
    },
  },
  watch: {
    currentNode() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_variables.scss';

.battery {
  height: 100%;

  .fineprint {
    font-size: 10px;
    line-height: 11px;
    // margin-top: -53px;
    margin-left: 20px;
    color: #ccc;
    a {
      color: #ccc;
      text-decoration: none;
    }
    a:hover {
      text-decoration: underline;
    }
  }
}

@media (min-width: $breakpoint-tablet) {
  .battery {
    .fineprint {
      position: fixed;
      bottom: 10px;
      left: 10px;
      margin-top: 0px;
    }
  }
}
</style>
